import { FormFicheOrganismeFormation } from "../../components/form/formFicheOrganismeFormation"
import { enumOrganismeFormationCategorie } from "../../enums/enumOrganismeFormationCategorie"

export const EditionFicheEcole = () => {
    return (
        <FormFicheOrganismeFormation
            organismeFormationCategorie={enumOrganismeFormationCategorie.ECOLE}
        />
    )
}